import { TextField } from '@mui/material';
import type { DashboardT } from 'business/definitions';
import GeneralModal from 'components/SharedComponents/Modals/GeneralModal';
import DashboardFolderSelectionTree from 'modules/decision/pages/AllDashboards/components/DashboardFolderEditMenu/DashboardFolderSelectionTree';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';

import { useCreateDashboard } from '../../pages/AllDashboards/hooks/createDashboard';

type Props = {
    isOpen: boolean;
    onCreate?: (arg1: DashboardT) => void;
    onClose: () => void;
    currentFolderId?: number | null;
};

const CreateDashboardModal = ({
    isOpen,
    onCreate = () => {},
    onClose,
    currentFolderId = null,
}: Props) => {
    const { t } = useTranslation();
    const initialTitle = t('dashboards.newDashboardPrefix');
    const [title, setTitle] = useState(initialTitle);
    const [selectedFolderId, setSelectedFolderId] = useState<number | null>(
        currentFolderId,
    );

    const createDashboardMutation = useCreateDashboard(onCreate);
    const createNewDashboard = () => {
        createDashboardMutation.mutate({ title, folderId: selectedFolderId });
        onClose();
    };

    const closeButton = {
        text: t('common.cancel'),
        onClick: onClose,
    };
    const containedButton = {
        text: t('common.save'),
        onClick: createNewDashboard,
    };

    return (
        <GeneralModal
            isOpen={isOpen}
            onClose={onClose}
            title={t('dashboards.create')}
            shouldCloseOnBackdropClick
            containedButton={containedButton}
            textButton={closeButton}
        >
            <Flex direction="column" gap={3}>
                <TextField
                    fullWidth
                    label={t('common.title')}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <DashboardFolderSelectionTree
                    selectedFolderId={selectedFolderId}
                    setSelectedFolderId={setSelectedFolderId}
                />
            </Flex>
        </GeneralModal>
    );
};

export default CreateDashboardModal;
